import React, { useState, useEffect } from 'react';
import { Layout, theme } from 'antd';
import Employee from '../employee';
import styles from './styles.module.scss';
import EmployeeListHeader from '../header-employee-list';

const { Content } = Layout;
interface EmployeeListProps {
  employeeList: any;
}
const style: React.CSSProperties = { background: '#0092ff', padding: '8px 0' };

const EmployeeList: React.FC<EmployeeListProps> = ({
  employeeList,
}: EmployeeListProps): JSX.Element => {
  console.log(employeeList);
  return (
    <>
      <Layout className={styles.layout}>
        <Content className={styles.container}>
          <div style={{ minWidth: '1000px' }}>
            <EmployeeListHeader />
            {employeeList.map((employee: any, index: number) => {
              return (

                <Employee {...{ employee: employee }} key={index} />

              );
            })}
          </div>
        </Content>
      </Layout>
    </>
  );
};

export default EmployeeList;
